import { Component } from '@angular/core';
import { HvtSection4Dto, TypeDetailDto } from '../../../models/notices/ojeu.notice.models';
import { OjeuEnumsToSelectList, FormType, ProcedureType } from '../../../models/notices/ojeu.notice.enums';
import { SelectableItem } from '../../../models/common/selectableItem';
import { HvtSectionBase } from './hvt.section.base';

@Component({
    selector: 'hvt-s4',
    template: require('./hvt.section.4.component.html')
})
export class HvtS4Component extends HvtSectionBase<HvtSection4Dto>{
    hvtS4: HvtSection4Dto;

    prodedureTypes: Array<SelectableItem<ProcedureType>>;

    constructor() {
        super();
        this.prodedureTypes = OjeuEnumsToSelectList.getProcedureTypeList();
    }

    populate(hvtS4: HvtSection4Dto, formType: FormType) {
        this.hvtS4 = hvtS4;
        this.formType = formType;
    }

    clear() {
        this.hvtS4 = null;
        this.formType = null;
    }

    getProcedureTypeText(typeDetail: TypeDetailDto) {
        var type = this.prodedureTypes.find(pt => {
            return pt.value === typeDetail.type;
        });

        if (this.hvtS4.eu201424Directive && type.value === ProcedureType.NegotiatedWithoutPublication) {
            return 'Negotiated procedure without prior publication';
        }

        if (this.hvtS4.ec200981Directive && type.value === ProcedureType.NegotiatedWithoutPublication) {
            return 'Negotiated procedure without publication of a contract notice';
        }

        if (type && type.value !== ProcedureType.AwardContractWithoutCall) {
            return type.text;
        }

        return '';
    }

    getSectionIV1s3Title() {
        if (this.formType === FormType.F152014 || this.formType === FormType.F212014) {
            return 'Information about framework agreement';
        }

        return 'Information about a framework agreement or a dynamic purchasing system';
    }

    showSectionIV1() {
        return (this.formType !== FormType.F242014) && this.formType !== FormType.F232014 ||
        ((this.formType === FormType.F242014 || this.formType === FormType.F232014) &&
            this.hvtS4.coveredByGpa !== null);
    }

    showSectionIV1s1() {
        return this.hvtS4.types.length > 0 ||
            this.hvtS4.ec200981Directive ||
            this.hvtS4.eu201423Directive ||
            this.hvtS4.eu201424Directive ||
            this.hvtS4.eu201425Directive;
    }

    showAwardContractWithoutPriorCall() {
        return this.hvtS4.types.some(
            (t: TypeDetailDto) => { return t.type === ProcedureType.AwardContractWithoutCall; });
    }

    showSectionIV1s3() {
        //Possibly when covered by GPA is not null?
        //312916, 312913, 313560, 313566, 313567, 313573, 313812, 315994
        //not shown if there is no procedure type?
        // 283876, 315300, 315301, 315302
        if (this.hvtS4.hasFramework ||
            this.hvtS4.dynamicPurchaseSystem ||
            this.hvtS4.additionalDynamicPurchasers ||
            this.hvtS4.dJustification ||
            this.formType === FormType.F152014 ||
            this.formType === FormType.F022014 ||
            this.formType === FormType.F062014 ||
            this.formType === FormType.F032014 || // 313567, 330993
            this.formType === FormType.F212014) { //323522
            return true;
        }

        return this.formType === FormType.F012014 && this.hvtS4.coveredByGpa !== null && (this.hvtS4.types.length > 0 || this.hvtS4.jsAwardScheduledDate);

    }

    showSectionIV1s3FrameworkDetails() {
        return this.hvtS4.hasFramework;
    }

    showSectionIV1s4() {
        return this.formType !== FormType.F012014 &&
            this.formType !== FormType.F032014 &&
            this.formType !== FormType.F042014 &&
            this.formType !== FormType.F062014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F212014 &&
            this.formType !== FormType.F242014;
    }

    showSectionIV1s5() {
        return this.hvtS4.rightToContractInitialTenderers;
    }

    showSectionIV1s6() {
        //283876 - NOT SHOWN
        //SHOWN:
        //283841, 283942, 283945, 283946, 283947, 283948, 302182, 302202, 302231, 304532, 304526, 
        //304878, 304941, 312913, 312916, 313173, 313560, 313566, 313567, 313573, 313812, 314181, 315994
        //346583

        if (this.formType !== FormType.F152014 &&
            this.hvtS4.hasFramework &&
            !(this.hvtS4.eAuction || this.hvtS4.eAuctionAdditionalInformation)) {
            return true;
        }

        if (this.formType === FormType.F012014) {
            return this.hvtS4.types.length > 0 || this.hvtS4.jsAwardScheduledDate;
        }

        //313567, 330993
        if (this.formType === FormType.F032014 && this.hvtS4.coveredByGpa) {
            return true;
        }

        return this.hvtS4.eAuction || this.hvtS4.eAuctionAdditionalInformation || this.formType === FormType.F062014;
    }

    showSectionIV1s8() {
        return this.hvtS4.coveredByGpa !== null;
    }

    showSectionIV1s9() {
        return this.hvtS4.criteriaEvaluation;
    }

    showSectionIV1s10() {
        return this.formType === FormType.F212014;
    }

    showSectionIV1s11() {
        return this.formType === FormType.F212014;
    }

    showSectionIV2() {
        return this.formType === FormType.F042014 ||
            this.formType === FormType.F152014 ||
            this.formType === FormType.F062014 ||
            this.formType === FormType.F032014 || //313566, 313567, 313994
            this.hvtS4.ojeuNoticeNumber ||
            this.hvtS4.jsTenderReceiptDate ||
            this.hvtS4.jsInvitationDispatchDate ||
            this.hvtS4.languages.length > 0 ||
            this.hvtS4.jsTenderValidDate ||
            this.hvtS4.duration ||
            this.hvtS4.openingCondition.jsOpeningDate ||
            this.hvtS4.openingCondition.furtherInfo ||
            this.hvtS4.openingCondition.location ||
            this.hvtS4.dpsTermination ||
            this.hvtS4.pinTermination ||
            this.hvtS4.jsAwardScheduledDate ||
            this.hvtS4.hasFramework; //302182
    }

    showSectionIV2s1() {
        return this.formType !== FormType.F232014 && //333131
            (this.formType === FormType.F042014 ||
            this.formType === FormType.F152014 ||
            this.formType === FormType.F062014 ||
            this.formType === FormType.F032014 || //313566, 313567, 313994
            this.hvtS4.ojeuNoticeNumber ||
            this.hvtS4.jsTenderReceiptDate ||
            this.hvtS4.jsInvitationDispatchDate ||
            this.hvtS4.languages.length > 0 ||
            this.hvtS4.jsTenderValidDate ||
            this.hvtS4.duration ||
            this.hvtS4.openingCondition.jsOpeningDate ||
            this.hvtS4.openingCondition.furtherInfo ||
            this.hvtS4.openingCondition.location ||
            this.hvtS4.dpsTermination ||
            this.hvtS4.pinTermination);
    }

    showSectionIV2s2() {
        return this.formType !== FormType.F032014 &&
            this.formType !== FormType.F152014 &&
            this.hvtS4.jsTenderReceiptDate;
    }

    showSectionIV2s3() {
        return this.formType !== FormType.F012014 &&
            this.formType !== FormType.F032014 &&
            this.formType !== FormType.F042014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F212014 &&
            this.formType !== FormType.F232014 &&
            this.formType !== FormType.F242014 &&
            this.formType !== FormType.F062014;
    }

    showSectionIV2s4() {
        return this.formType !== FormType.F032014 && this.formType !== FormType.F152014 && this.hvtS4.languages.length > 0;
    }

    showSectionIV2s5() {
        return this.formType === FormType.F012014 || this.hvtS4.jsAwardScheduledDate;
    }

    showSectionIV2s6() {
        return this.formType !== FormType.F012014 &&
            this.formType !== FormType.F032014 &&
            this.formType !== FormType.F042014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F212014 &&
            this.formType !== FormType.F232014 &&
            this.formType !== FormType.F242014 &&
            this.formType !== FormType.F062014;
    }

    showSectionIV2s7() {
        return this.formType !== FormType.F012014 &&
            this.formType !== FormType.F032014 &&
            this.formType !== FormType.F042014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F212014 &&
            this.formType !== FormType.F232014 &&
            this.formType !== FormType.F242014 &&
            this.formType !== FormType.F062014;
    }

    showSectionIV2s8() {
        return this.formType === FormType.F032014 || this.formType === FormType.F062014;
    }

    showSectionIV2s9() {
        return this.formType === FormType.F032014 ||
            this.formType === FormType.F062014 ||
            (this.formType === FormType.F212014 && this.hvtS4.isContractAward);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.4.component.ts